<div class="fn_ks__container is-fullwidth">
  <div class="fn_ks__container__col">
    <div class="fn_ks__component fn_ks__page-header">
      <h1 class="fn_ks__page-header__title"><span class="fn_ks__page-header__content-type"></span>Search</h1>
      <div class="fn_ks__page-header__subtitle"></div>
      <div class="fn_ks__page-header__posteddate"></div>
    </div>
    <div id="fn_ks__search-wrap">
      <div>
        <div class="fn_ks__search__bar">
          <div class="fn_ks__search__bar-form" action="" role="search">
            <label for="fn_ks__search__bar-input"> <span class="visuallyhidden">Search</span></label>
            <div class="fn_ks__search__bar-wrapper">
              <input
                type="text"
                placeholder="Search"
                [(ngModel)]="inputSearchTerm"
                class="fn_ks__search__bar-field"
                id="fn_ks__search__bar-input"
                name="inputSearchTerm"
                value=""
              />
              <button
                type="button"
                class="fn_ks__button--searchbtn fn_ks__search__bar-submit"
                (click)="getSearchResults(inputSearchTerm)"
              >
                <span>Search</span>
              </button>
            </div>
          </div>
          <div class="fn_ks__search__bar-meta" *ngIf="searchedData.length > 0">
            {{ searchedData.length }} results found | Displaying 1-{{ displayedItems.length }} of
            {{ searchedData.length }} for {{ inputSearchTerm }}
          </div>
          <div class="fn_ks__search__bar-meta" *ngIf="searchedData.length === 0">No results</div>
        </div>
        <div class="fn_ks__search__result">
          <ul class="fn_ks__search__result-list">
            <li *ngFor="let Search of displayedItems">
              <div class="fn_ks__search__result-item">
                <!-- Wrap the title in an anchor tag to make it clickable -->
                <a [href]="Search.url" class="fn_ks__search__result-title">{{ Search.title }}</a>
              </div>
            </li>
          </ul>
        </div>
        <div class="fn_ks__search__result-loadmore" *ngIf="hasMoreItems()">
          <button class="fn_ks__button fn_ks__button--arrow" type="button" (click)="viewMore()">
            View More
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 64 32"
              enable-background="new 0 0 64 32"
              xml:space="preserve"
              role="presentation"
              focusable="false"
            >
              <path fill="currentColor" d="M0,11.9h43.8V0L64,15.5L43.8,32V20.1H0V11.9z"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
